<ng-container *ngIf="getEntries() as entries">
  <div class="metadata-card" *ngIf="entries.length">
    <div class="metadata-row" *ngFor="let entry of entries; trackBy: trackByEntry">
      <span>{{ entry.label }}</span>
      <span>{{ entry.value }}</span>
    </div>
  </div>
</ng-container>
